/**
 * Les liens d'invitation reviennent à leur écran après connexion. Seuls les
 * chemins internes sont admis : une URL absolue ne doit jamais devenir une
 * redirection ouverte.
 */
export function destinationApresConnexion(
  recherche: string,
  retourEtat?: unknown
): string {
  const parametres = new URLSearchParams(recherche);
  const candidat =
    parametres.get('redirect') ??
    parametres.get('retour') ??
    (typeof retourEtat === 'string' ? retourEtat : '/');

  return candidat.startsWith('/') && !candidat.startsWith('//')
    ? candidat
    : '/';
}
